module.exports = __webpack_public_path__ + "img/nature-72.f8c780b4.jpg";